// MIGRATION: Using ConvexNotificationContext instead of legacy NotificationContext
import { useNotifications as useNotificationContext } from '../context/ConvexNotificationContext';
import { useFeatureFlag } from './useFeatureFlag';

// Feature flags now use Statsig - these constants are kept for compatibility
const NOTIFICATION_FLAGS = {
  INFRASTRUCTURE_ENABLED: 'notification_infrastructure_enabled'
};

export const useNotifications = () => {
  // Call ALL hooks at the top level unconditionally - React Rules of Hooks
  const featureFlag = useFeatureFlag(NOTIFICATION_FLAGS.INFRASTRUCTURE_ENABLED);
  const context = useNotificationContext();

  // Return disabled state if infrastructure is not enabled
  // useFeatureFlag returns { isEnabled: boolean, isLoading: boolean, error: Error | null }
  if (!featureFlag.isEnabled) {
    return {
      bellNotifications: [],
      unreadCount: 0,
      bannerNotifications: [],
      activeBanner: null,
      historyNotifications: [],
      historyLoading: false,
      markAsRead: async () => false,
      dismissNotification: async () => false,
      markAllAsRead: async () => {},
      refreshNotifications: async () => {},
      isLoading: false,
      error: null
    };
  }

  // Infrastructure is enabled, return the actual context
  return context;
}; 